import React, { memo } from 'react'
import { DialogContent, DialogActions, Box } from '@mui/material'

import { QB_ACTION_SUBMIT } from '../../../constants/input'
import CustomForm from '../customForm/CustomForm'
import CustomButton from '../buttons/CustomButton'

const CustomDialogContent = ({
  body,
  onClose,
  onSubmit,
  cancelProps,
  submitProps = {},
  additionalActions,
  customCss,
  isForm,
  actionStyles
}) => {
  const { ...restSubmitProps } = submitProps
  const submitStyleProps = {
    variant: 'contained',
    fullWidth: false,
    ...restSubmitProps
  }

  const dialogContent = (
    <>
      {body && (
        <DialogContent sx={{ pt: 2, pb: 0, pr: 4, pl: 4, ...customCss }}>
          {body}
        </DialogContent>
      )}
      <DialogActions sx={{ p: 4, ...actionStyles }}>
        {onClose && (
          <CustomButton
            onClick={onClose}
            variant='outlined'
            color='primary'
            {...cancelProps}
          />
        )}
        <Box sx={{ flex: '1 1 auto' }} />
        {Object.keys(submitProps).length ? (
          <>
            {additionalActions}
            {isForm && (
              <CustomButton type={QB_ACTION_SUBMIT} {...submitStyleProps} />
            )}
          </>
        ) : (
          <></>
        )}
      </DialogActions>
    </>
  )
  return isForm ? (
    <CustomForm onFormSubmit={onSubmit}>{dialogContent}</CustomForm>
  ) : (
    dialogContent
  )
}

export default memo(CustomDialogContent)
